import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { User } from 'lucide-react';
import { PlayerSelectorModal } from './PlayerSelectorModal';

interface PlayerSelection {
  playerName: string;
  jerseyNo: number;
  teamName: string;
  jerseyUrl: string;
}

interface PlayerPickerButtonProps {
  onSelect: (selection: PlayerSelection) => void;
  selectedTeams: string[];
  fieldLabel?: string;
  disabled?: boolean;
}

export function PlayerPickerButton({
  onSelect,
  selectedTeams,
  fieldLabel,
  disabled = false,
}: PlayerPickerButtonProps) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setModalOpen(true)}
        disabled={disabled}
        className="shrink-0"
        title={disabled && selectedTeams.length === 0 ? 'Select teams first' : 'Select player'}
      >
        <User className="h-4 w-4" />
      </Button>
      <PlayerSelectorModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        onSelect={onSelect}
        selectedTeams={selectedTeams}
        fieldLabel={fieldLabel}
      />
    </>
  );
}
